import React, { Component } from "react";

export default class Payment extends Component {
  render() {
    return (
      <div className="payment flex space-btw">
        <div className="info">
          <p className="thick">{this.props.title}</p>
          <p className="date">{this.props.mini_text}</p>
        </div>
        <p className="amount thick">
          ₦{this.props.cost}<small className="thick">.00</small>
        </p>
      </div>
    );
  }
}
